import { Component } from '@theme/component';

/** @extends {Component<{track: HTMLElement, navigation: HTMLElement, previous: HTMLButtonElement, next: HTMLButtonElement}>} */
class KnProductCarousel extends Component {
  #controller;
  #observer;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    super.disconnectedCallback();
  }

  #bind() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.#controller = new AbortController();
    const track = this.refs.track;
    if (!track) return;
    track.addEventListener('scroll', () => this.#update(), { passive: true, signal: this.#controller.signal });
    this.#observer = new ResizeObserver(() => this.#update());
    this.#observer.observe(track);
    document.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element)) return;
      const card = event.target.closest('.kn-merchandise-card');
      if (card && this.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    }, { signal: this.#controller.signal });
    this.#update();
  }

  #update() {
    const { track, previous, next, navigation } = this.refs;
    if (!track) return;
    const limit = track.scrollWidth - track.clientWidth;
    const offset = Math.abs(track.scrollLeft);
    if (navigation) navigation.hidden = limit < 2;
    if (previous) previous.disabled = offset < 2;
    if (next) next.disabled = offset >= limit - 2;
  }

  /** @param {number} direction */
  #move(direction) {
    const track = this.refs.track;
    const card = track?.firstElementChild;
    if (!track || !(card instanceof HTMLElement)) return;
    const style = getComputedStyle(track);
    const step = card.getBoundingClientRect().width + parseFloat(style.columnGap);
    track.scrollBy({ left: step * direction * (style.direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  previous() { this.#move(-1); }
  next() { this.#move(1); }
}

if (!customElements.get('kn-product-carousel')) customElements.define('kn-product-carousel', KnProductCarousel);
